import type { AxiosResponse } from 'axios';
import axios from 'axios';

import type { Tokens } from '../api';

interface TokensResponse extends Tokens {
  success: boolean;
}

const API_ROOT = `/api/v1/sites`;

/**
 * Create / replace the Hubspot OAuth integration.
 *
 * @param siteId Id of site to store the token for.
 * @param accessToken OAuth access token.
 * @param refreshToken OAuth refresh token.
 */
export const storeIntegration = (
  siteId: string,
  accessToken: string,
  refreshToken: string,
): Promise<AxiosResponse> => {
  return axios.put<{ success: boolean }>(`${API_ROOT}/${siteId}/oauth-tokens/hubspot-oauth2`, {
    access_token: accessToken,
    refresh_token: refreshToken,
  });
};

/**
 * Use the code that the oauth2 API returns to request the actual access and refresh tokens.
 *
 * @param siteId Id of site to store the token for.
 * @param code OAuth access code returned by initial authorization.
 */
export const getTokensWithCode = (siteId: string, code: string): Promise<AxiosResponse> => {
  return axios.post<TokensResponse>(`${API_ROOT}/${siteId}/integrations/hubspot`, {
    action: 'request_keys',
    code,
  });
};

/**
 * Disconnect the Hubspot OAuth integration.
 *
 * @param providerStr either 'hubspot' or 'hubspot-oauth2'.
 * @param siteId Id of site to store the token for.
 */
export const removeIntegration = (providerStr: string, siteId: string): Promise<AxiosResponse> => {
  return axios.delete<{ success: boolean }>(`${API_ROOT}/${siteId}/oauth-tokens/${providerStr}`);
};
